<template>
  <div>
    <div v-if="!hasFields()" class="row">
      <div class="col-12 text-center">
        <div class="p-t-40">
          <h3 class="">
            You don't have any fields added yet.
          </h3>
          <button class="btn btn-lg btn-stem" @click="addField()">
            <i class="fas fa-plus" />&nbsp; Add Field
          </button>
        </div>
      </div>
    </div>

    <div v-if="hasFields()" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-md-flex align-items-center">
              <div>
                <h4 class="card-title">
                  <i class="fas fa-th" />&nbsp;Fields
                </h4>
                <h5 class="card-subtitle">
                  Configure fields in this farm
                </h5>
              </div>
              <div class="ml-auto d-flex no-block align-items-center">
                <div class="dl">
                  <button class="btn waves-effect waves-light btn-success" @click="addField()">
                    <i class="fas fa-plus" />&nbsp;Add Field
                  </button>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table no-wrap v-middle">
                <thead>
                  <tr class="border-0">
                    <th class="border-0">
                      Name
                    </th>
                    <th class="border-0">
                      Location
                    </th>
                    <th class="border-0">
                      Area
                    </th>
                    <th class="border-0">
                      Cadastral Plot
                    </th>
                    <th class="border-0">
                      Soil
                    </th>
                    <th class="border-0">
                      Ownership Type
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(field, index) in fieldList" :key="index">
                    <td>{{ field.name }}</td>
                    <td>{{ field.location }}</td>
                    <td>{{ field.area.amount }} {{ field.area.units }}</td>
                    <td>{{ field.cadastral_plot }}</td>
                    <td>{{ field.soil.text }}</td>
                    <td>{{ field.ownership.text }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="text-right">
          <nav aria-label="Page navigation example">
            <paginate :click-handler="pageHandler" :container-class="'pagination float-right'" :margin-pages="2" :next-class="'page-link'" :next-text="'Next'" :page-class="'page-link'" :page-count="pageCount" :page-range="3" :prev-class="'page-link'" :prev-text="'Prev'" />
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'

export default {
  name: 'FieldList',
  components: { Paginate },
  data () {
    return {
      fieldList: [],
      pageCount: 1,
      total: 0,
      soilTypes: [
        { value: 'CLAY', text: 'Clay' },
        { value: 'CLAY_LOAM', text: 'Clay Loam' },
        { value: 'SAND', text: 'Sand' },
        { value: 'LOAM', text: 'Loam' },
        { value: 'LOAMY_SAND', text: 'Loamy Sand' },
        { value: 'SANDY_CLAY', text: 'Sandy Clay' },
        { value: 'SANDY_CLAY_LOAM', text: 'Sandy Clay Loam' },
        { value: 'SILT', text: 'Silt' },
        { value: 'SILT_LOAM', text: 'Silt Loam' },
        { value: 'SILT_CLAY', text: 'Silty Clay' },
        { value: 'SILT_CLAY_LOAM', text: 'Silty Clay Loam' }
      ],
      ownershipTypes: [
        { value: 'PRIVATELY_OWNED', text: 'Privately Owned' },
        { value: 'LEASE', text: 'Lease' },
        { value: 'GIVEN_FOR_USE', text: 'Given for Use' },
        { value: 'PROPERTY_MANAGER', text: 'Property Manager' },
        { value: 'OWNED_BY_RELATIVES', text: 'Owned by Relatives' },
        { value: 'MIXED', text: 'Mixed' },
        { value: 'OTHER', text: 'Other' }
      ]
    }
  },
  mounted () {
    this.getFieldList(1)
  },
  methods: {
    addField () {
      this.$router.push({ name: 'newfield' })
    },
    hasFields () {
      return this.fieldList.length > 0
    },
    async getFieldList (page) {
      const reply = await this.$api.get('/fields', {
        params: {
          page: page,
          perPage: 10
        }
      })

      this.total = reply.data.totalSize
      this.fieldList = reply.data.slice

      this.fieldList.map(field => {
        field.soil = this.soilTypes.find(r => r.value === field.soil)
        field.ownership = this.ownershipTypes.find(r => r.value === field.ownership)
      })
      this.setPageCount()
    },
    pageHandler (pageNum) {
      this.getFieldList(pageNum)
    },
    setPageCount () {
      this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10)
    }
  }
}
</script>

<style scoped>
</style>
